import Indicador from "..";
import PEscEditFields from "./components/PEscEditFields";
import { PEscParamFields } from "./components/PEscParamFields";
import ReportSummary from "./reports/summary";
import apontamentoReport from "./reports/index";


export default class PEsc extends Indicador {
    static get fullName() {
        return "Profundidade de Escarificação";
    }

    static get abbrev() {
        return "P.Esc.";
    }

    static get field() {
        return "pesc";
    }

    static paramFields(tipoIndicadorField = '') {
        return <PEscParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <PEscEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;
        const total = apontamento.coletas.length;

        for (const coleta of apontamento.coletas) {
            if (
                f(coleta.profundidadeColeta) >= f(params.intervaloMin) &&
                f(coleta.profundidadeColeta) <= f(params.intervaloMax)
            ) {
                coleta.conforme = "Sim";
                conformeCount++;
            } else {
                coleta.conforme = "Não";
            }
        }
        return ((100 * conformeCount) / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 89.47, 100, 103.15);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.profundidadeColeta)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getResultStr(apontamento) {
        if (!apontamento.coletas || !apontamento.coletas.length) return "";
        const total = apontamento.coletas.length;
        const conformeCount = apontamento.coletas.filter((c) => c.conforme === "Sim").length;
        const media = (
            apontamento.coletas.reduce((s, c) => s + parseFloat(c.profundidadeColeta || 0), 0) / total
        ).toFixed(2);
        return `Profundidade média: ${media} cm, Conformes: ${conformeCount} de ${total}`;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            { title: "Talhão", field: "talhao.nome" },
            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },
            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }
}
